// extracted by css-extract-rspack-plugin
module.exports =  {"container":"BookkeepingManagerTableTotal__container___nioW1","total":"BookkeepingManagerTableTotal__total___bFQz8"};